var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcSuccess = function SvgIcSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#82C160",
    fillRule: "evenodd",
    d: "M2 12C2 6.477 6.477 2 12 2A10 10 0 1 1 2 12m9.73 3.61 4.57-6v-.03a1.006 1.006 0 0 0-1.6-1.22l-3.78 5-1.63-2.08a1.001 1.001 0 0 0-1.58 1.23l2.44 3.11a1 1 0 0 0 1.58-.01",
    clipRule: "evenodd"
  })));
};
export default SvgIcSuccess;